export default "__VITE_ASSET__DOeslVbZ__"